<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.receiverType')"
            v-model.trim="data.receiverTypeTranslated"
            disabled
          />

          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.Notifications.notification')"
            v-model.trim="data.type"
            disabled
          /> -->

          <div class="col-12">
            <div class="row">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                disabled
              />

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                disabled
              />

              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.bodyAr"
                disabled
              />

              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.bodyEn"
                disabled
              />

              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.send_date')"
                v-model.trim="data.createdAt"
                disabled
              />
            </div>
          </div>
        </div>
      </form>

      <div class="table_title_wrapper mt-4">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.recievers") }}</h5>
        </div>
      </div>

      <v-data-table
        class="thumb"
        :loading="loadingRecipients"
        :loading-text="$t('TABLES.loadingData')"
        :headers="tableHeaders"
        :items="tableRows"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <template v-slot:[`item.serial`]="{ index }">
          {{
            (paginations.current_page - 1) * paginations.items_per_page +
            index +
            1
          }}
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <span>{{ item.name || "-" }}</span>
        </template>

        <template v-slot:[`item.mobile`]="{ item }">
          <span dir="ltr">{{ item.mobile || "-" }}</span>
        </template>

        <template v-slot:[`item.is_read`]="{ item }">
          <v-chip
            small
            :color="item.is_read ? 'green' : 'orange'"
            text-color="white"
          >
            {{ item.is_read ? $t("BUTTONS.yes") : "-" }}
          </v-chip>
        </template>

        <template v-slot:[`item.read_at`]="{ item }">
          <span>{{ item.read_at || "-" }}</span>
        </template>
      </v-data-table>

      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShowNotification",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      loadingRecipients: false,

      data: {
        receiverTypeTranslated: null,
        titleAr: null,
        titleEn: null,
        bodyAr: null,
        bodyEn: null,
        createdAt: null,
        type: null,
      },

      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "serial",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Users.name"),
          value: "name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Users.phone"),
          value: "mobile",
          align: "center",
          sortable: false,
        },

      ],
      tableRows: [],

      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 15,
      },
    };
  },

  watch: {
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.getNotificationData();
    },
  },

  methods: {
    getTargetTypeName(type) {
      const names = {
        client: this.$t("PLACEHOLDERS.service_seeker_singular"),
        clients: this.$t("PLACEHOLDERS.all_service_seekers"),
        driver: this.$t("PLACEHOLDERS.driver_name"),
        drivers: this.$t("PLACEHOLDERS.driver_name"),
        provider: this.$t("PLACEHOLDERS.service_provider_singular"),
        providers: this.$t("PLACEHOLDERS.service_providers_plural"),
        all: this.$t("PLACEHOLDERS.both"),
      };

      return names[type] || type;
    },

    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });
    },

    async getNotificationData() {
      this.loadingRecipients = true;

      try {
        const res = await this.$axios({
          method: "GET",
          url: `/notification/show/${this.$route.params.id}`,
          params: {
            page: this.paginations.current_page,
          },
        });

        const notificationData = res.data?.data || {};
        const usersData = notificationData.users?.data || [];
        const usersMeta = notificationData.users?.meta || {};

        this.data.titleAr = notificationData.title_ar;
        this.data.titleEn = notificationData.title_en;
        this.data.bodyAr = notificationData.body_ar;
        this.data.bodyEn = notificationData.body_en;
        this.data.createdAt = notificationData.created_at;
        this.data.type = notificationData.type;

        const targetTypes = notificationData.metadata?.target_types || [];
        this.data.receiverTypeTranslated = targetTypes
          .map((type) => this.getTargetTypeName(type))
          .join(" - ");

        this.tableRows = usersData;
        this.paginations.current_page = usersMeta.current_page || 1;
        this.paginations.last_page = usersMeta.last_page || 1;
        this.paginations.items_per_page = usersMeta.per_page || 15;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      } finally {
        this.loadingRecipients = false;
      }
    },
  },

  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.getNotificationData();
  },
};
</script>
